













































import { Component, Prop, Vue } from "vue-property-decorator";
import { gallerys } from "@/config/host.config";

import ButtonBack from "@/components/buttons/button-back.vue";
import GalleryFormatList from "@/components/tables/gallery/gallery-format-list.vue";
import GalleryFormatForm from "@/components/forms/gallery/gallery-format-form.vue";

import { IPhotoFormat } from "@/@types/gallsery/gallery";
import { AxiosResponse } from "axios";

@Component({
  components: { ButtonBack, GalleryFormatList, GalleryFormatForm },
})
export default class GalleryFormats extends Vue {
  @Prop({ type: Array, default: () => [] }) formats!: Array<IPhotoFormat>;
  deleted = false;
  idFormat = "";

  get photoFormat(): IPhotoFormat | null {
    if (!this.idFormat) return null;
    for (const format of this.formats) {
      if (format._id == this.idFormat) return format;
    }
    return null;
  }

  // POST PUT format
  async changeFormat(data: IPhotoFormat): Promise<void> {
    let uri = this.photoFormat
      ? gallerys.formats + "/" + this.photoFormat._id
      : gallerys.formats;
    const method = this.photoFormat ? "put" : "post";

    try {
      const res: AxiosResponse<IPhotoFormat> = await this.$axios({
        method: method,
        url: uri,
        data: data,
      });
      if (res.status === 200) {
        this.idFormat = "";
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });

        this.$emit("createFormats", this.photoFormat ? data : res.data);
      }
    } catch (error) {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }
}
